import { createContext, ReactNode, useEffect, useMemo } from 'react';

export interface AudioContextProps {
  audioElement: HTMLMediaElement | null;
}

export const AudioContext = createContext<AudioContextProps>({
  audioElement: null,
});

const AudioProvider = ({ children }: { children: ReactNode }) => {
  const audioElement = useMemo(() => new Audio(), []);

  useEffect(
    () => () => {
      audioElement.pause();
      audioElement.remove();
    },
    [audioElement]
  );

  return (
    <AudioContext.Provider value={{ audioElement }}>
      {children}
    </AudioContext.Provider>
  );
};

export default AudioProvider;
